import css from "standard/css";

const style = css`
  :root {
    --line-height-default: 100%;
    --line-height-xs: 115%;
    --line-height-sm: 120%;
    --line-height-md: 133%;
    --line-height-lg: 150%;
    --line-height-xl: 170%;
    --line-height-xxl: 200%;
  }
`;

export default style;
